import { LogicContext } from '@/logic/main/types';
import Location from '@/ports-frontend/Location';

export const runGameFromDirectLink = (context: LogicContext) => async () => ({
  shouldRunTheGame:
    (await Location.get()).pathname !== context.gameToLaunch?.gameLaunchPath,
});
